import React, { useState, useEffect, createContext } from "react";
//import * as locationData from "./data/starbucks.json";

const DataContext = createContext([{}, () => {}]);

const DataProvider = props => {
  const [searchResults, updateResults] = useState([]);

  // const handleUpdateData = () => {
  //   let storesArray = [];
  //   locationData.stores.map(place => {
  //     storesArray.push(place);
  //   });

  //   if (data.length !== storesArray.length) {
  //     let parseData = JSON.parse(JSON.stringify(storesArray));
  //     updateData(parseData);
  //   }
  // };

  //handleUpdateData();

  // useEffect(() => {

  //   if (searchResults[0] !== undefined) {
  //     console.log(searchResults[0].address_components[4].short_name);
  //   }
  // }),
  //   [searchResults];

  return (
    <DataContext.Provider value={[searchResults, updateResults]}>
      {props.children}
    </DataContext.Provider>
  );
};

export { DataContext, DataProvider };
